<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-01-12 10:07:37
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-12 10:12:07
 * @FilePath: /chaoyongtuan/src/views/shopManage/components/extensionDrawer/tableCell/goodsBox.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="flex-row-align-center">
		<div class="pic mt-2">
			<el-avatar shape="square" :size="64" :src="row.product_pic"></el-avatar>
		</div>
		<div class="details font-h6-regular ml-8">
			<div class="flex-row-align-center">
				<platform-icon :platformId="row.platform_id ? row.platform_id : platformId"></platform-icon>
				<el-tooltip placement="top" :content="row.product_name" v-ak-tooltip-auto-show>
					<p class="yx-color-text-primary line-ellipsis ml-6" style="max-width: 180px">{{ row.product_name }}</p>
				</el-tooltip>
			</div>
			<p class="goodsId-color mt-2">商品ID：{{ row.third_product_id }}</p>
			<div class="shop-tag mt-4">
				<el-tooltip class="item" effect="dark" :content="row.shop_name" :disabled="isTipShopName" placement="top">
					<span>店铺：{{ row.shop_name | textFormat(14) | formatEmpty }}</span>
				</el-tooltip>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	components: {},
	props: {
		row: {
			type: Object,
			default: () => {},
		},
		platformId: {
			type: [Number, String],
			default: dataMap.PLATFORM_DY.value,
		},
	},
	data() {
		return {};
	},
	computed: {
		isTipShopName({ row }) {
			let name = row.shop_name;
			return name && name.length > 6 ? false : true;
		},
	},
};
</script>
<style lang="less" scoped>
.shop-tag {
	height: 18px;
	line-height: 18px;
	border-radius: 2px;
	text-align: center;
	font-size: 12px;
	margin-top: 4px;
	display: inline-block;
	color: @color-gy7;
}
.goodsId-color {
	color: @color-gy7;
}
</style>
